import React from 'react'
import DevProduct from "../../imagens/devProduto/devProduto.png"
import DevProduct2 from "../../imagens/devProduto/devProduto2.png"
import DevProduct3 from "../../imagens/devProduto/devProduto3.png"
import DevProduct4 from "../../imagens/devProduto/devProduto4.png"
import DevProduct5 from "../../imagens/devProduto/devProduto5.png"
import DevProduct6 from "../../imagens/devProduto/devProduto6.png"
import DevProduct7 from "../../imagens/devProduto/devProduto7.png"
import DevProduct8 from "../../imagens/devProduto/devProduto8.png"
import DevProduct9 from "../../imagens/devProduto/devProduto9.png"
import DevProduct10 from "../../imagens/devProduto/devProduto10.png"
import DevProduct11 from "../../imagens/devProduto/devProduto11.png"
import DevProduct12 from "../../imagens/devProduto/devProduto12.png"
import DevProduct13 from "../../imagens/devProduto/devProduto13.png"
import DevProduct14 from "../../imagens/devProduto/devProduto14.png"
import DevProduct15 from "../../imagens/devProduto/devProduto15.png"
import DevProduct16 from "../../imagens/devProduto/devProduto16.png"
import DevProduct18 from "../../imagens/devProduto/devProduto18.png"
import DevProduct19 from "../../imagens/devProduto/devProduto19.png"
import DevProduct20 from "../../imagens/devProduto/devProduto20.png"
import DevProduct21 from "../../imagens/devProduto/devProduto21.png"
import DevProduct22 from "../../imagens/devProduto/devProduto22.png"
import DevProduct23 from "../../imagens/devProduto/devProduto23.png"
import DevProduct24 from "../../imagens/devProduto/devProduto24.png"
import Header from '../../Components/Header'
import EngineeringCapabilities from '../../Components/engineeringCapabilities'



const listDevProduct = [
    {
        img: DevProduct21
    },
    {
        img: DevProduct22
    },
    {
        img: DevProduct23
    },
    {
        img: DevProduct24
    },
    {
        img: DevProduct
    },
    {
        img: DevProduct2
    },
    {
        img: DevProduct3
    },
    {
        img: DevProduct4
    },
    {
        img: DevProduct5
    },
    {
        img: DevProduct6
    },
    {
        img: DevProduct7
    },
    {
        img: DevProduct8
    },
    {
        img: DevProduct9
    },
    {
        img: DevProduct10
    },
    {
        img: DevProduct11
    },
    {
        img: DevProduct12
    },
    {
        img: DevProduct13
    },
    {
        img: DevProduct14
    },
    {
        img: DevProduct15
    },
    {
        img: DevProduct16
    },
    {
        img: DevProduct18
    },
    {
        img: DevProduct19
    },
    {
        img: DevProduct20
    },

]






const EngineerPage = () => {
return (
    <div>
        <Header/>
            <EngineeringCapabilities
                listDevProduct = {listDevProduct}
            />
    </div>
)
}

export default EngineerPage